import { Component, AfterContentInit, OnDestroy } from '@angular/core';

import {
  TaskDTO,
  ActionDTO,
  LinkedActionsDTO,
  ActionParameterDTO,
  ActionParameterTypeDTO,
  ActionTypeDTO,
  WorkDTO
} from '../api/plyca-dtos';
import { TaskService } from './task.service';
import { Router } from '@angular/router';
import { PlycaDataService } from '../../services/plyca.service';
import { ServiceLocator } from './../ServiceLocator';
import * as objectPath from 'object-path';

import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { finalize, switchMap } from 'rxjs/operators';
import { HelpType, HelpService } from '../components/common/help/help.service';
import { generateRandomIdentifier } from '../ui.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { TranslateService } from '@ngx-translate/core';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';

export class TaskDTOModal {
  constructor(public task: TaskDTO, public fixedAction?: any) { }
}

export class TaskDTOModalResult {
  public success = true;
  public message: string;
}

@Component({
  selector: 'task-actions-process',
  templateUrl: 'task.actions.process.template.html'
})
export class taskActionsProcessComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  context: TaskDTOModal;
  public model: TaskActionsModel;
  private taskService: TaskService;
  private plycaService: PlycaDataService;
  private translate: TranslateService;
  private route: Router;
  private tagsParent: string[];

  windowHash: string;

  constructor(
    public ref: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private waitService: WaitLoadingService,
    private helpService: HelpService,
    private plycaErrorHandler: PlycaErrorHandler
  ) {
    super();

    this.windowHash = generateRandomIdentifier();

    this.helpContext();
    this.taskService = ServiceLocator.injector.get(TaskService);
    this.plycaService = ServiceLocator.injector.get(PlycaDataService);
    this.translate = ServiceLocator.injector.get(TranslateService);

    this.model = new TaskActionsModel(
      dialogConfig['context'].task,
      dialogConfig['context'].fixedAction,
      this.translate.instant('TaskActions.errorWarning'),
      this.plycaErrorHandler
    );

    this.route = ServiceLocator.injector.get(Router);
    this.waitService.cancelWaiting();
  }
  ngAfterContentInit(): void {
    this.waitService.cancelWaiting();
  }

  helpContext() {

    let signTask = false;
    if (
      this.model &&
      this.model.task &&
      this.model.task.availableActions &&
      this.model.task.availableActions.actions
    ) {
      this.model.task.availableActions.actions.forEach((action: ActionDTO) => {
        if (action.identifier === 'DOCUMENT_SIGN') {
          signTask = true;
        }
      });
    }
    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      switchMap((helpTags) => {
        this.tagsParent = helpTags
        if (signTask) {
          return this.helpService.showContextHelpObservable(HelpType.DEVOL_FIRMA);
        } else {
          return this.helpService.showContextHelpObservable(HelpType.OPC_TAREA);
        }
      })));
  }

  ngOnDestroy() {
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {


        this.dialogConfig = null;
        this.ref = null;
        super.ngOnDestroy();
      })));
  }

  /**
  * Transforma un path JSON en string en un array de propiedades para su uso por
  * la libreria de objectPath
  */
  private jsonPathToArray(path: string): any {
    console.log('string path ', path);
    let rowObjectPath;
    if (path) {
      rowObjectPath = path.replace(/\[|(\].)/g, '.');
      console.log('row path ', rowObjectPath);
      if (rowObjectPath.endsWith('.')) {
        rowObjectPath = rowObjectPath.substring(0, rowObjectPath.length - 1);
      }
      console.log('row path modificado', rowObjectPath);

    }

    return rowObjectPath;
  }

  public patch(action: ActionDTO): void {
    this.waitService.startWaiting();
    // DUDAS !!! : ¿Puedo pasar mantener/despachar por put general?, ¿tengo que hacer savework en put general?
    // OJO /mantain que devuelve JSON da un 404 -> anyadir a path REST unlock
    if (this.isUnlockOrMantain(action)) {
      this.mantain();
    } else if (action.identifier === ActionTypeDTO.TASK_DISPATCH) {
      this.dispatch();
    } else if (action.links) {
      console.log(this.model.updatedWork);

      // actualizar parametros con constantes de la accion
      if (action.parameters) {
        action.parameters
          .filter(
            (parameter: ActionParameterDTO) =>
              parameter.actionType === ActionParameterTypeDTO.CONST
          )
          .forEach((parameter: ActionParameterDTO) =>
            objectPath.set(
              this.model.updatedWork,
              this.jsonPathToArray(parameter.jsonPath),
              parameter.value
            )
          );
      }
      this.waitService.startWaiting();
      this.subscribe(this.taskService
        .processAction(this.model.task, this.model.updatedWork, action)
        .pipe(
          finalize(() => {

          })
        ),
        () => {
          console.log('Accion ejecutada.');
          this.closeOK();
        },
        (err: any) => {
          this.closeWithError(err, 'Error manejando la tarea');
        }
      );
    }
  }


  public mantain(): void {
    console.log('TaskHandler.mantain');
    if (this.model.task.work) {
      this.waitService.startWaiting();
      this.subscribe(this.taskService
        .unlockTask(this.model.task, false),
        ok => {
          console.log('manteniendo tarea');
          this.closeOK();
        },
        err => {
          this.waitService.cancelWaiting();
          this.closeWithError(err, 'Error manteniendo la tarea');
        }
      );
    } else {
      this.closeWithError(null, 'La tarea no tiene trabajo asociado');
    }
  }

  dispatch(): void {
    console.log('TaskHandler.dispatch');
    if (this.model.task.work) {
      this.waitService.startWaiting();
      this.subscribe(this.taskService.dispatchTask(this.model.task),
        ok => {
          console.log('dispatch tarea');
          this.closeOK();
        },
        err => {
          this.waitService.cancelWaiting();
          this.closeWithError(err, this.plycaErrorHandler.getErrorMessage(err, 'Error despachando la tarea'));
        }
      );
    } else {
      this.closeWithError(null, 'La tarea no tiene trabajo asociado');
    }
  }

  private closeWithError(err: any, msg: string): void {
    if (err) {
      console.log(err);
    }
    let result = new TaskDTOModalResult();
    result.success = false;
    result.message = msg;
    this.ref.close(result);
  }

  private closeOK(): void {
    this.ref.close(new TaskDTOModalResult());
  }

  public closeWindow(): void {
    this.ref.close();
  }

  public updateProperty(propertyPath: string, event: any): void {
    objectPath.set(this.model.updatedWork, this.jsonPathToArray(propertyPath), event);
  }


  public getUpdatedWorkProperty(propertyPath: string): string {
    return objectPath.get(this.model.updatedWork, this.jsonPathToArray(propertyPath)) as string;
  }

  classAction(action: ActionDTO): string {
    if (this.isUnlockOrMantain(action)) {
      return 'btn-warning';
    } else {
      return 'btn-primary';
    }
  }

  classActionIcon(action: ActionDTO): string {
    if (this.isUnlockOrMantain(action)) {
      return 'fas fa-unlock';
    } else if (action.identifier === ActionTypeDTO.TASK_DISPATCH) {
      return 'fas fa-check';
    } else {
      return '';
    }
  }

  private isUnlockOrMantain(action: ActionDTO): boolean {
    return (
      action.identifier === ActionTypeDTO.TASK_UNLOCK ||
      action.identifier === ActionTypeDTO.TASK_MANTAIN
    );
  }

  public getPrimaryActions(): Array<ActionDTO> {
    let mainActions: Array<ActionDTO> = new Array<ActionDTO>();
    let auxArray = this.model.task.availableActions;
    if (auxArray) {
      mainActions = mainActions.concat(
        auxArray.actions.filter(action => !this.isUnlockOrMantain(action))
      );
    }
    auxArray = this.model.workActions;
    if (auxArray) {
      mainActions = mainActions.concat(
        auxArray.actions.filter(action => !this.isUnlockOrMantain(action))
      );
    }
    return mainActions;
  }

  public getSecondaryActions(): Array<ActionDTO> {
    let mainActions: Array<ActionDTO> = new Array<ActionDTO>();
    let auxArray = this.model.task.availableActions;
    if (auxArray) {
      mainActions = mainActions.concat(
        auxArray.actions.filter(action => this.isUnlockOrMantain(action))
      );
    }
    auxArray = this.model.workActions;
    if (auxArray) {
      mainActions = mainActions.concat(
        auxArray.actions.filter(action => this.isUnlockOrMantain(action))
      );
    }
    return mainActions;
  }
}

class TaskActionsModel {
  public workActions: LinkedActionsDTO;
  public updatedWork: WorkDTO;
  public validationErrors: string;
  private errorMsg: string;

  constructor(public task: TaskDTO, public fixedAction: any, errorMsg: string, plycaErrorHandler: PlycaErrorHandler) {
    this.updatedWork = {} as WorkDTO;
    this.task = task;
    this.errorMsg = errorMsg;
    let excludeUnlock = function (action: ActionDTO): boolean {
      let ret = true;
      // explicitamente se filtra la accion de desbloquear
      ret = action.identifier !== ActionTypeDTO.TASK_UNLOCK;
      // si se ha fijado una accion, se filtran el resto
      if (this.fixedAction) {
        ret = action.identifier === this.fixedAction;
      }
      return ret;
    };
    if (task.work.validationResult && task.work.validationResult.errors && task.work.validationResult.result
      && task.work.validationResult.result !== 'OK') {

      this.validationErrors = plycaErrorHandler.getErrorMessage(task.work.validationResult);
    }

    // this.taskActions = this.getActiveActions(task.availableActions, excludeUnlock);
    this.workActions = task.work.availableActions
      ? this.getActiveActions(task.work.availableActions, excludeUnlock)
      : undefined;
    console.log(task, this.workActions);
  }

  private getActiveActions(
    actions: LinkedActionsDTO,
    filterFunction?: Function
  ): LinkedActionsDTO {
    let activeActions: LinkedActionsDTO = new LinkedActionsDTO();
    activeActions.actions = new Array();
    activeActions.parameters = actions.parameters;
    console.log(filterFunction);
    actions.actions
      .filter((action: ActionDTO) => action.enabled)
      .filter((action: ActionDTO) =>
        filterFunction ? filterFunction.call(this, action) : true
      )
      .forEach((action: ActionDTO) => activeActions.actions.push(action));
    return activeActions;
  }



}
